import React from "react";
import MarketingFlyerModalBody from "./MarketingFlyerModalBody";
import GenerateImageEditorButtons from "./GenerateImageEditorButtons";
import { Grid } from "@mui/material";

const MarketingFlyerModalBodyContainer = (props) => {
    const {
        handleCloseModal,
        handleGenerateMarketingFlyerReport,
        handleSelectPhotoFromDropdown,
        shouldDisableButtons,
    } = props;

    return (
        <React.Fragment>
            <MarketingFlyerModalBody {...props} />
            <Grid item xs={4} style={{ paddingTop: "22px", textAlign: "end" }}>
                <GenerateImageEditorButtons
                    handleCloseModal={handleCloseModal}
                    handleGenerateClick={handleGenerateMarketingFlyerReport}
                    handleSelectPhotoFromDropdown={handleSelectPhotoFromDropdown}
                    shouldDisableButtons={shouldDisableButtons}
                />
            </Grid>
        </React.Fragment>
    );
};

export default MarketingFlyerModalBodyContainer;
